import React from 'react';
import InfinityMark from './brand/InfinityMark';

// Route-level loader: the brand mark spins in an endless loop.
// `light` keeps it on a light background for pages that stay light (client offers).
function Loader({ label = 'INFINITY', light = false }) {
  return (
    <div className={`w-full h-screen flex flex-col items-center justify-center ${light ? 'bg-[#f9f9f9]' : 'bg-obsidian'}`} role="status" aria-live="polite">
      <InfinityMark tone={light ? 'light' : 'dark'} motion="loop" size={84} title="Učitavanje" />
      <span className={`mt-7 text-[10px] font-light tracking-[0.5em] uppercase ${light ? 'text-black/40' : 'text-white/40'}`}>{label}</span>
    </div>
  );
}

export default Loader;
